import React, { useEffect, useState } from 'react';
import Header from "./Header";
import { Link } from 'react-router-dom';
import Footer from "./footer";

interface Group {
    group: { ID: string, name: string }
}

const App: React.FC = () => {
    const [groups, setGroups] = useState<Group[]>([]);

    useEffect(() => {
        fetch('https://korbball.turnverband.ch/ws/groupsV1.php').then(response => response.json())
            .then((jsonData) => {
                // jsonData is parsed json object received from url
                console.log(jsonData);
                setGroups(jsonData);
            })
            .catch((error) => {
                // handle your errors here
                console.error(error)
            });
    }, []);

    const favorites_str = localStorage.getItem('favorites');
    let favorites_json = favorites_str ? JSON.parse(favorites_str) : [];

    console.log(favorites_json);

    return (
        <div className="App">
            <Header/>
            <div className="App-container">
                <h3>Meine Favoriten</h3>
                <ul className="teams">
                    {favorites_json.map((element: { id: string; team_name: string; groupId: string }) => <li key={element.id}>
                        <Link to={`group/${element.groupId}/team/${element.id}`}>{element.team_name}</Link>
                    </li>)}
                </ul>
                <h3>Alle Ligen</h3>
                <ul className="teams">
                    {groups.map(element => <li key={element.group.ID}>
                        <Link to={`group/${element.group.ID}`}>{element.group.name}</Link>
                    </li>)}
                </ul>
            </div>
            <Footer/>
        </div>
    );
}

export default App;
